import { PositionList } from '@ui/features/Trade/components/PositionList/PositionList';
import { usePositions } from '@ui/hooks/trade/usePositions';
import { Text } from '@ui/lib/park/ui/text';
import { useTranslation } from 'next-i18next';
import { Center } from 'styled-system/jsx';
import type { Address } from 'viem';

export const Positions = ({
  hideFilters,
  userAddress,
  showHeaderTotals,
}: {
  hideFilters?: boolean;
  userAddress?: Address;
  showHeaderTotals?: boolean;
}) => {
  const { data: positions } = usePositions(userAddress);

  return (
    <PositionList
      positions={positions || []}
      emptyView={<Empty />}
      showCurrentPairToggle={!hideFilters}
      showHeaderTotals={showHeaderTotals}
    />
  );
};

const Empty = () => {
  const { t } = useTranslation();

  return (
    <Center py="6">
      <Text textStyle="v2.ui" color="v2.text.subtle">
        {t("common.You currently don't have any positions")}
      </Text>
    </Center>
  );
};
